"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselItem = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var carousel_item_module_scss_1 = __importDefault(require("./carousel-item.module.scss"));
var CarouselItem = function (_a) {
    //* Accessibility implementation commented out for now,
    //* look at revising work on this following testing with Fable.
    // const TAB_KEY = 'Tab';
    // const listItemRef = useRef<HTMLLIElement>(null);
    var item = _a.item, index = _a.index, itemsCount = _a.itemsCount, 
    //handleKeyUp,
    itemNumber = _a.itemNumber;
    // const handleKeyUpOnItem = (event) => {
    //   if (event.key === TAB_KEY) {
    //     const pageNumber = getPageNumberAttribute(listItemRef.current);
    //     handleKeyUp(pageNumber);
    //   }
    // };
    // const getPageNumberAttribute = (listItem: HTMLLIElement | null): number => {
    //   return listItem?.dataset.pagenumber ? +listItem.dataset.pagenumber : NaN;
    // };
    return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    react_1.default.createElement("div", { className: (0, classnames_1.default)(carousel_item_module_scss_1.default['carousel__item']), "aria-roledescription": "slide", "aria-label": "".concat(itemNumber, " of ").concat(itemsCount), "data-index": index, role: "listitem", "data-testid": "item-".concat(itemNumber) }, item));
};
exports.CarouselItem = CarouselItem;
//# sourceMappingURL=CarouselItem.js.map